<script>
import _ControlsBox from './_ControlsBox';

export default {
  name: 'ControlsBoxGame',
  components: {
    ControlsBox: _ControlsBox,
  },
  props: {
    game: {
      required: true,
    },
  },
};
</script>

<template lang="pug">
  ControlsBox
    span(slot="title") {{ $t('Game controls') }}
    div(slot="controls", v-if="game")
      p.desctrigger.white.fw6.f7.mb3(v-if="game.controlsTrigger") #[em.fw7.f7.b--green.mb1.dib.ttu.green Trigger] #[br]#[span(v-html="game.controlsTrigger")]
      p.descgrip.white.fw6.f7.mb3(v-if="game.controlsGrip") #[em.fw7.f7.b--green.mb1.dib.ttu.green Grip] #[br]#[span(v-html="game.controlsGrip")]
      p.descmenu.white.fw6.f7.mb3(v-if="game.controlsMenu") #[em.fw7.f7.b--green.mb1.dib.ttu.green Menu] #[br]#[span(v-html="game.controlsMenu")]
      p.desctouchpad.white.fw6.f7.mb3(v-if="game.controlsTouchpad") #[em.fw7.f7.b--green.mb1.dib.ttu.green Touchpad] #[br]#[span(v-html="game.controlsTouchpad")]
      p.descextra.white.fw6.f7.mb3(v-if="game.controlsExtra") #[em.fw7.f7.b--green.mb1.dib.ttu.green Extra] #[br]#[span(v-html="game.controlsExtra")]

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.controls-box {
}
</style>
